import { UserProfile } from 'api/account/models/UserProfile';
import UsersService from 'api/users/UsersService';
import VehiclesService from 'api/vehicles/VehiclesService';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Reducers } from 'store/types';

// God mode (Platform Admin): seed one-time da capacidade do tanque (litros) a partir do GPS.
// Síncrono — grava tudo num pedido e mostra aqui o resultado (nº de ativos preenchidos).
// Render incondicional (a rota já está protegida por PolicyRoute); o guard de admin fica só
// na chamada à API. useEffect depende do userProfile para correr assim que o perfil hidratar.
const PrefillCapacityFromGps: React.FC = () => {
    const { t } = useTranslation();
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const [status, setStatus] = useState<'running' | 'done' | 'error'>('running');
    const [updated, setUpdated] = useState<number>(0);
    const startedRef = useRef(false);

    const run = async () => {
        if (startedRef.current || !UsersService.isPlatformAdmin(userProfile?.roles)) {
            return;
        }
        startedRef.current = true;
        try {
            const result = await VehiclesService.prefillCapacityFromGps();
            setUpdated(result.updated);
            setStatus('done');
        } catch {
            setStatus('error');
        }
    };

    useEffect(() => {
        run();
    }, [userProfile]);

    return (
        <div style={{ padding: '40px' }}>
            <h2>{t('god_modes.items.prefill_capacity_from_gps.title') as string}</h2>
            {status === 'running' &&
                <p style={{ color: '#374151' }}>{t('god_modes.prefill_running') as string}</p>
            }
            {status === 'done' &&
                <p style={{ color: '#0f766e', fontWeight: 600 }}>
                    {updated > 0
                        ? (t('god_modes.prefill_done', { count: updated }) as string)
                        : (t('god_modes.prefill_none') as string)}
                </p>
            }
            {status === 'error' &&
                <p style={{ color: '#b91c1c', fontWeight: 600 }}>{t('common.messages.error_load_info') as string}</p>
            }
        </div>
    );
};

export default PrefillCapacityFromGps;
